import React, { createContext, useState, useContext } from "react";

interface GlobalContextType {
  setTotalAmount: React.Dispatch<React.SetStateAction<string>>;
  totalAmount: string;
  setTotalFees: React.Dispatch<React.SetStateAction<string>>;
  totalFees: string;
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("usePayment must be used within a PaymentProvider");
  }
  return context;
};

export const GlobalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [totalAmount, setTotalAmount] = useState("");
  const [totalFees, setTotalFees] = useState("");
  return (
    <GlobalContext.Provider
      value={{
        totalAmount,
        setTotalAmount,
        totalFees,
        setTotalFees,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
